export const chunkItems = <T>(items: T[], size: number) => {
  return items.reduce(
    (array, _, index) =>
      index % size ? array : [...array, items.slice(index, index + size)],
    [] as T[][],
  );
};
